import(/* webpackMode: "eager", webpackExports: ["Content"] */ "/home/runner/work/joyboy/joyboy/apps/web/app/[deviceTheme]/[region]/[locale]/help-center/components/content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageClient"] */ "/home/runner/work/joyboy/joyboy/apps/web/app/[deviceTheme]/[region]/[locale]/help-center/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/shared/observability/src/lib/client-logging.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/packages/monorepo-i18n/src/lib/scripts/useTranslation.client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["formatCurrencyClient"] */ "/home/runner/work/joyboy/joyboy/packages/monorepo-i18n/src/lib/utils/currency-format.client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["getLocaleClient"] */ "/home/runner/work/joyboy/joyboy/packages/monorepo-i18n/src/lib/utils/locale.client.ts");
